import React from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { TextImageStacked } from '../../templates';
import { ImageType } from '../../../utils/types';

import './styles.css';

type Props = {
	content: {
		landingPage: {
			docBuilder: {
				badge: {
					label: string;
					text: string;
				};
				heading: string;
				subheading: string;
				buttonLabel: string;
				href: string;
				image: ImageType;
			}
		}
	}
};

/**
 *
 * @typedef {Object} Props
 *
 * @augments {Component<Props>}
 */
const DocBuilderView: React.FC<Props> = (props: Props) => {

	const {
		badge,
		heading,
		subheading,
		buttonLabel,
		href,
		image,
	} = props.content.landingPage.docBuilder;

	return (
		<TextImageStacked
			{...{
				badge,
				heading,
				subheading,
				buttonLabel,
				href,
				image,
			}}
			className='DocBuilderView'
		/>
	);

};

export default withLanguageContext(DocBuilderView);
